import { Component, Input } from '@angular/core';

@Component({
  selector: 'tcc-bool-visualizer',
  templateUrl: './bool-visualizer.component.html',
  styleUrls: ['./bool-visualizer.component.scss']
})
export class BoolVisualizerComponent {

  @Input() value: boolean;
  @Input() size: number;


  constructor() {
  }

}
